var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBugoMessageBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6334 14.4101L16 3.97339L3.3667 14.4101V28.0267H28.6334V14.4101Z",
    fill: "#0186B5",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3667 14.41L16 24.8467L28.6334 14.41",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27686 15.9868L16.0002 24.8468L26.6602 16.0401V5.78345H5.27686V15.9868Z",
    fill: "white",
    stroke: "#1F2937",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5304 19.6267C16.8337 19.7934 16.2037 20.1367 15.4837 20.2134C15.4004 20.2234 15.267 20.2134 15.1304 20.2001C15.147 20.2134 15.1637 20.2301 15.1837 20.2434C15.467 20.4601 15.7837 20.6301 16.1204 20.7401C17.2037 21.0901 18.2637 20.7034 19.1804 20.1201C18.9037 19.5367 18.107 19.4867 17.5337 19.6234L17.5304 19.6267Z",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6937 14.6634C20.6537 14.72 20.6137 14.7734 20.5704 14.8267C20.2104 15.27 19.7471 15.5867 19.2804 15.91C18.6837 16.3267 17.8037 17.1834 18.2304 17.9034C19.2504 17.5034 20.1937 16.8434 20.5304 15.75C20.5904 15.56 20.6804 15.06 20.6937 14.66V14.6634Z",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9502 15.3201C15.9502 15.3201 18.9035 18.0834 19.7769 21.7267",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2501 10.26C16.2501 10.26 16.6767 8.50005 17.1501 8.51338C17.6234 8.52671 17.9634 9.38338 17.9301 11.8034C17.8967 14.2234 15.9367 15.35 15.9367 15.35C14.7934 15.9567 13.3134 15.98 11.4467 14.6167C9.5134 13.15 9.53673 12.6234 9.59673 12.39C9.71673 12.0967 10.6334 12.2367 11.5334 12.5767",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2037 13.0067C17.2037 13.0067 16.267 9.05004 15.097 9.12671C14.4537 9.12671 14.8204 11.3234 14.8204 11.3234",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3167 15.02C13.3167 15.02 10.4967 11.9434 11.27 11.0634C11.66 10.5534 13.26 12.2167 13.26 12.2167",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4536 14.4701C14.4536 14.4701 12.1669 10.6234 13.1236 10.0568C14.0802 9.49011 16.0702 13.6034 16.0702 13.6034",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8901 15.4301L17.7601 12.8301",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8536 9.93003C17.8536 9.93003 19.3303 8.77003 19.3069 9.74336C19.2836 10.7167 17.7603 12.9934 17.7603 12.9934",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3835 13.8267C10.3835 13.8267 8.59018 14.3833 9.40351 14.9167C10.2168 15.45 12.9568 15.4867 12.9568 15.4867",
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBugoMessageBlue);
export default __webpack_public_path__ + "static/media/icon-bugo-message-blue.496a7f78b3cb32494daba177de0b756f.svg";
export { ForwardRef as ReactComponent };